<div [formGroup]="form" class="py-2">
  <div class="flex justify-between gap-4 items-center">
    <mat-form-field
      class="input-tg mt-message-input w-3/12"
      appearance="outline"
    >
      <mat-label>Tipo pagamento</mat-label>
      <mat-select formControlName="paymentTypeId">
        @for (type of listType; track type) {
          <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field
      class="input-tg mt-message-input w-7/12"
      appearance="outline"
    >
      <mat-label>Prazo</mat-label>
      <input matInput formControlName="term" />
    </mat-form-field>

    <button mat-flat-button class="btn-tg w-1/12" (click)="cancel()">
      Cancel
    </button>
    @if (this.editItem.edit) {
      <button
        mat-flat-button
        class="btn-tg w-1/12"
        [disabled]="form.invalid || loading"
        (click)="editPaymentMethod()"
      >
        @if (loading) {
          <mat-spinner
            diameter="22"
            class="loading-spinner"
            selected-track-color="red"
          ></mat-spinner>
        } @else {
          Editar
        }
      </button>
    } @else {
      <button
        mat-flat-button
        class="btn-tg w-1/12"
        [disabled]="form.invalid || loading"
        (click)="createPaymentMethod()"
      >
        @if (loading) {
          <mat-spinner
            diameter="22"
            class="loading-spinner"
            selected-track-color="red"
          ></mat-spinner>
        } @else {
          Adicionar
        }
      </button>
    }
  </div>
</div>
